// "use client";

// import { useState, useEffect } from "react";
// import {
//   Box,
//   Modal,
//   Typography,
//   TextField,
//   Button,
//   Select,
//   MenuItem,
//   FormControl,
//   InputLabel,
//   IconButton,
//   Snackbar,
//   Alert,
//   AlertColor,
//   SelectChangeEvent,
// } from "@mui/material";
// import CloseIcon from "@mui/icons-material/Close";

// interface FormDataState {
//   name: string;
//   email: string;
//   interest: string;
//   phone: string;
//   consent: boolean;
// }

// interface SnackbarState {
//   open: boolean;
//   message: string;
//   severity: AlertColor;
// }

// export default function ExitIntentForm() {
//   const [open, setOpen] = useState<boolean>(false);
//   const [triggered, setTriggered] = useState<boolean>(false);
//   const [formData, setFormData] = useState<FormDataState>({
//     name: "",
//     email: "",
//     interest: "",
//     phone: "",
//     consent: false,
//   });
//   const [errors, setErrors] = useState<Record<string, string>>({});
//   const [snackbar, setSnackbar] = useState<SnackbarState>({
//     open: false,
//     message: "",
//     severity: "success",
//   });

//   useEffect(() => {
//     let lastClientY = 0;
//     const detectionThreshold = 100;
//     const requiredSpeed = 50;
//     let lastMoveTime = Date.now();

//     const handleIntent = () => {
//       if (triggered || sessionStorage.getItem("exitIntentShown")) return;
//       setOpen(true);
//       setTriggered(true);
//       sessionStorage.setItem("exitIntentShown", "true");
//       document.body.style.overflow = "hidden";
//     };

//     const handleMouseMove = (e: MouseEvent) => {
//       const now = Date.now();
//       const timeDiff = now - lastMoveTime;
//       const speed = Math.abs(e.clientY - lastClientY) / (timeDiff || 1);

//       if (
//         (e.clientY < detectionThreshold && speed > requiredSpeed) ||
//         e.clientY < 20
//       ) {
//         handleIntent();
//       }

//       lastClientY = e.clientY;
//       lastMoveTime = now;
//     };

//     const handleMouseLeave = (e: MouseEvent) => {
//       if (e.clientY <= 0 && !triggered) {
//         handleIntent();
//       }
//     };

//     const handleTouchMove = (e: TouchEvent) => {
//       const touch = e.touches[0];
//       if (touch.clientY < detectionThreshold && !triggered) {
//         handleIntent();
//       }
//     };

//     if (!sessionStorage.getItem("exitIntentShown")) {
//       window.addEventListener("mousemove", handleMouseMove);
//       window.addEventListener("mouseleave", handleMouseLeave);
//       window.addEventListener("touchmove", handleTouchMove);
//     }

//     return () => {
//       window.removeEventListener("mousemove", handleMouseMove);
//       window.removeEventListener("mouseleave", handleMouseLeave);
//       window.removeEventListener("touchmove", handleTouchMove);
//     };
//   }, [triggered]);

//   const validateForm = () => {
//     const newErrors: Record<string, string> = {};
//     if (!formData.name) newErrors.name = "Name is required";
//     if (!formData.email) {
//       newErrors.email = "Email is required";
//     } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
//       newErrors.email = "Invalid email address";
//     }
//     if (!formData.interest) newErrors.interest = "Please select an option";
//     if (!formData.consent) newErrors.consent = "Consent is required";
//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const handleSubmit = async (e: React.FormEvent) => {
//     e.preventDefault();
//     if (!validateForm()) return;

//     try {
//       await fetch("/api/submitToAirtable", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({
//           name: formData.name,
//           email: formData.email,
//           interest: formData.interest,
//           consent: formData.consent,
//         }),
//       });
//       setSnackbar({
//         open: true,
//         message: "Thank you! We'll contact you shortly.",
//         severity: "success",
//       });
//       handleClose();
//     } catch (error) {
//       console.error("Submission error:", error);
//       setSnackbar({
//         open: true,
//         message: "Submission failed. Please try again.",
//         severity: "error",
//       });
//     }
//   };

//   const handleChange = (
//     e: React.ChangeEvent<
//       HTMLInputElement | HTMLTextAreaElement | { name?: string; value: unknown }
//     >
//   ) => {
//     const name = e.target.name as keyof FormDataState;
//     const value = e.target.value;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//     setErrors((prev) => ({ ...prev, [name]: "" }));
//   };

//   const handleSelectChange = (e: SelectChangeEvent<string>) => {
//     setFormData((prev) => ({
//       ...prev,
//       interest: e.target.value,
//     }));
//     setErrors((prev) => ({ ...prev, interest: "" }));
//   };

//   const handleClose = () => {
//     setOpen(false);
//     document.body.style.overflow = "auto";
//   };

//   const handleCloseSnackbar = () => {
//     setSnackbar((prev) => ({ ...prev, open: false }));
//   };

//   return (
//     <>
//       <Modal open={open} onClose={handleClose}>
//         <Box
//           sx={{
//             position: "absolute",
//             top: "50%",
//             left: "50%",
//             transform: "translate(-50%, -50%)",
//             width: { xs: "90%", sm: 500 },
//             bgcolor: "background.paper",
//             backgroundImage:
//               "linear-gradient(135deg, #001f3f 0%, #00060d 100%)",
//             borderRadius: 2,
//             boxShadow: 24,
//             p: 4,
//             color: "common.white",
//           }}
//         >
//           <IconButton
//             sx={{
//               position: "absolute",
//               right: 8,
//               top: 8,
//               color: "common.white",
//             }}
//             onClick={handleClose}
//           >
//             <CloseIcon />
//           </IconButton>

//           <Typography
//             variant="h4"
//             component="h2"
//             gutterBottom
//             sx={{ color: "secondary.main", marginBottom: 3 }}
//           >
//             Wait! Let Us Help You Find the Perfect Solution 🚀
//           </Typography>

//           <form onSubmit={handleSubmit}>
//             <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
//               <TextField
//                 fullWidth
//                 name="name"
//                 label="Your Name"
//                 value={formData.name}
//                 onChange={handleChange}
//                 error={!!errors.name}
//                 helperText={errors.name}
//                 sx={{
//                   "& .MuiOutlinedInput-root": {
//                     color: "common.white",
//                     "& fieldset": { borderColor: "grey.300" },
//                   },
//                   "& .MuiInputLabel-root": { color: "grey.300" },
//                 }}
//               />

//               <TextField
//                 fullWidth
//                 name="email"
//                 label="Work Email"
//                 value={formData.email}
//                 onChange={handleChange}
//                 error={!!errors.email}
//                 helperText={errors.email}
//                 sx={{
//                   "& .MuiOutlinedInput-root": {
//                     color: "common.white",
//                     "& fieldset": { borderColor: "grey.300" },
//                   },
//                   "& .MuiInputLabel-root": { color: "grey.300" },
//                 }}
//               />

//               <FormControl fullWidth error={!!errors.interest}>
//                 <InputLabel sx={{ color: "grey.300" }}>
//                   What brings you here?
//                 </InputLabel>

//                 <Select
//                   name="interest"
//                   value={formData.interest}
//                   onChange={handleSelectChange}
//                   label="What brings you here?"
//                   sx={{
//                     color: "common.white",
//                     "& .MuiSvgIcon-root": { color: "grey.300" },
//                     "& .MuiOutlinedInput-notchedOutline": {
//                       borderColor: "grey.300",
//                     },
//                   }}
//                 >
//                   <MenuItem value="new-website">
//                     New Website Development
//                   </MenuItem>
//                   <MenuItem value="redesign">Website Redesign</MenuItem>
//                   <MenuItem value="automation">Automation Solutions</MenuItem>
//                   <MenuItem value="ai/chatbot">AI/Chatbot Development</MenuItem>
//                   <MenuItem value="other">Other</MenuItem>
//                 </Select>
//                 {errors.interest && (
//                   <Typography variant="caption" color="error">
//                     {errors.interest}
//                   </Typography>
//                 )}
//               </FormControl>

//               <FormControl error={!!errors.consent}>
//                 <label style={{ display: "flex", alignItems: "center" }}>
//                   <input
//                     type="checkbox"
//                     name="consent"
//                     checked={formData.consent}
//                     onChange={(e) => {
//                       setFormData({ ...formData, consent: e.target.checked });
//                       setErrors({ ...errors, consent: "" });
//                     }}
//                     style={{ marginRight: "8px" }}
//                   />
//                   <Typography
//                     variant="body2"
//                     fontSize={13}
//                     sx={{ color: "grey.300" }}
//                   >
//                     I consent to LinXar Labs contacting me about my project
//                     needs
//                   </Typography>
//                 </label>
//                 {errors.consent && (
//                   <Typography variant="caption" color="error">
//                     {errors.consent}
//                   </Typography>
//                 )}
//               </FormControl>

//               <Button
//                 type="submit"
//                 variant="contained"
//                 color="secondary"
//                 size="large"
//                 sx={{
//                   mt: 2,
//                   py: 1.5,
//                   fontWeight: 600,
//                   "&:hover": {
//                     transform: "translateY(-2px)",
//                     boxShadow: 3,
//                   },
//                   transition: "transform 0.2s, box-shadow 0.2s",
//                 }}
//               >
//                 Get Custom Solution →
//               </Button>
//             </Box>
//           </form>

//           <Typography variant="body1" sx={{ mt: 2, color: "grey.400" }}>
//             We respect your privacy. No spam guaranteed.
//           </Typography>
//         </Box>
//       </Modal>

//       <Snackbar
//         open={snackbar.open}
//         autoHideDuration={6000}
//         onClose={handleCloseSnackbar}
//         anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
//       >
//         <Alert
//           onClose={handleCloseSnackbar}
//           severity={snackbar.severity}
//           sx={{ width: "100%" }}
//         >
//           {snackbar.message}
//         </Alert>
//       </Snackbar>
//     </>
//   );
// }

"use client";

import { useState, useEffect } from "react";
import {
  Box,
  Modal,
  Typography,
  TextField,
  Button,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  IconButton,
  Snackbar,
  Alert,
  AlertColor,
  SelectChangeEvent,
  useTheme,
  alpha,
  Fade,
  Slide,
  Avatar,
} from "@mui/material";
import {
  Close,
  RocketLaunch,
  Email,
  Person,
  Phone,
  CheckCircle,
  ArrowForward,
} from "@mui/icons-material";

interface FormDataState {
  name: string;
  email: string;
  interest: string;
  phone: string;
  message?: string;
  consent: boolean;
}

interface SnackbarState {
  open: boolean;
  message: string;
  severity: AlertColor;
}

export default function ExitIntentForm() {
  const theme = useTheme();
  const [open, setOpen] = useState<boolean>(false);
  const [triggered, setTriggered] = useState<boolean>(false);
  const [formData, setFormData] = useState<FormDataState>({
    name: "",
    email: "",
    interest: "",
    phone: "",
    message: "",
    consent: false,
  });
  const [errors, setErrors] = useState<Record<string, string>>({});
  const [snackbar, setSnackbar] = useState<SnackbarState>({
    open: false,
    message: "",
    severity: "success",
  });
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  useEffect(() => {
    let lastClientY = 0;
    const detectionThreshold = 100;
    const requiredSpeed = 50;
    let lastMoveTime = Date.now();

    const handleIntent = () => {
      if (triggered || sessionStorage.getItem("exitIntentShown")) return;
      setOpen(true);
      setTriggered(true);
      sessionStorage.setItem("exitIntentShown", "true");
      document.body.style.overflow = "hidden";
    };

    const handleMouseMove = (e: MouseEvent) => {
      const now = Date.now();
      const timeDiff = now - lastMoveTime;
      const speed = Math.abs(e.clientY - lastClientY) / (timeDiff || 1);

      if (
        (e.clientY < detectionThreshold && speed > requiredSpeed) ||
        e.clientY < 20
      ) {
        handleIntent();
      }

      lastClientY = e.clientY;
      lastMoveTime = now;
    };

    const handleMouseLeave = (e: MouseEvent) => {
      if (e.clientY <= 0 && !triggered) {
        handleIntent();
      }
    };

    const handleTouchMove = (e: TouchEvent) => {
      const touch = e.touches[0];
      if (touch.clientY < detectionThreshold && !triggered) {
        handleIntent();
      }
    };

    if (!sessionStorage.getItem("exitIntentShown")) {
      window.addEventListener("mousemove", handleMouseMove);
      window.addEventListener("mouseleave", handleMouseLeave);
      window.addEventListener("touchmove", handleTouchMove);
    }

    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseleave", handleMouseLeave);
      window.removeEventListener("touchmove", handleTouchMove);
    };
  }, [triggered]);

  const validateForm = () => {
    const newErrors: Record<string, string> = {};
    if (!formData.name.trim()) newErrors.name = "Name is required";
    if (!formData.email) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Please enter a valid email address";
    }
    if (!formData.interest) newErrors.interest = "Please select an option";
    if (!formData.consent) newErrors.consent = "Consent is required to proceed";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!validateForm()) return;

    setIsSubmitting(true);
    try {
      await fetch("/api/submitToAirtable", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name: formData.name,
          email: formData.email,
          interest: formData.interest,
          phone: formData.phone,
          message: formData.message,
          consent: formData.consent,
        }),
      });
      setSnackbar({
        open: true,
        message:
          "Perfect! We'll contact you within 24 hours with your custom solution.",
        severity: "success",
      });
      handleClose();
    } catch (error) {
      console.error("Submission error:", error);
      setSnackbar({
        open: true,
        message:
          "Something went wrong. Please try again or contact us directly.",
        severity: "error",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const name = e.target.name as keyof FormDataState;
    const value = e.target.value;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleSelectChange = (e: SelectChangeEvent<string>) => {
    setFormData((prev) => ({
      ...prev,
      interest: e.target.value,
    }));
    setErrors((prev) => ({ ...prev, interest: "" }));
  };

  const handleClose = () => {
    setOpen(false);
    document.body.style.overflow = "auto";
  };

  const handleCloseSnackbar = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  const interestOptions = [
    { value: "web-development", label: "Web Development", emoji: "🌐" },
    { value: "automation", label: "Automation Solutions", emoji: "⚡" },
    { value: "ai-chatbot", label: "AI & Chatbot Development", emoji: "🤖" },
    { value: "it-support", label: "IT Support & Maintenance", emoji: "🔧" },
    { value: "consultation", label: "Technical Consultation", emoji: "💡" },
    { value: "other", label: "Other Project", emoji: "✨" },
  ];

  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        closeAfterTransition
        sx={{
          backdropFilter: "blur(8px)",
        }}
      >
        <Fade in={open} timeout={600}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: { xs: "95%", sm: 500, md: 600 },
              maxWidth: "90vw",
              maxHeight: "90vh",
              overflow: "auto",
              bgcolor: "background.paper",
              borderRadius: 4,
              boxShadow: `0 32px 64px ${alpha(theme.palette.common.black, 0.3)}`,
              border: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
              background: `linear-gradient(135deg, ${theme.palette.background.paper} 0%, ${alpha(theme.palette.background.paper, 0.95)} 100%)`,
            }}
          >
            {/* Header */}
            <Box
              sx={{
                background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%)`,
                color: "white",
                p: 4,
                position: "relative",
                borderTopLeftRadius: 12,
                borderTopRightRadius: 12,
              }}
            >
              <IconButton
                sx={{
                  position: "absolute",
                  right: 16,
                  top: 16,
                  color: "white",
                  background: alpha(theme.palette.common.black, 0.2),
                  "&:hover": {
                    background: alpha(theme.palette.common.black, 0.3),
                  },
                }}
                onClick={handleClose}
              >
                <Close />
              </IconButton>

              <Box
                sx={{ display: "flex", alignItems: "center", gap: 2, mb: 2 }}
              >
                <Avatar
                  sx={{
                    width: 60,
                    height: 60,
                    background: alpha(theme.palette.common.white, 0.2),
                    color: "white",
                  }}
                >
                  <RocketLaunch sx={{ fontSize: 32 }} />
                </Avatar>
                <Box>
                  <Typography
                    variant="h4"
                    component="h2"
                    sx={{
                      fontWeight: 700,
                      fontSize: { xs: "1.75rem", sm: "2rem" },
                      lineHeight: 1.2,
                    }}
                  >
                    Let&apos;s Build Something Amazing! 🚀
                  </Typography>
                  <Typography variant="body1" sx={{ opacity: 0.9, mt: 1 }}>
                    Share your vision and we&apos;ll craft the perfect solution
                  </Typography>
                </Box>
              </Box>
            </Box>

            {/* Form Content */}
            <Box sx={{ p: 4 }}>
              <form onSubmit={handleSubmit}>
                <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
                  {/* Personal Info Grid */}
                  <Box
                    sx={{
                      display: "grid",
                      gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
                      gap: 2,
                    }}
                  >
                    <TextField
                      fullWidth
                      name="name"
                      label="Your Name"
                      value={formData.name}
                      onChange={handleChange}
                      error={!!errors.name}
                      helperText={errors.name}
                      InputProps={{
                        startAdornment: (
                          <Person sx={{ color: "text.secondary", mr: 1 }} />
                        ),
                      }}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: 2,
                          background: alpha(theme.palette.primary.main, 0.02),
                        },
                      }}
                    />

                    <TextField
                      fullWidth
                      name="email"
                      label="Work Email"
                      type="email"
                      value={formData.email}
                      onChange={handleChange}
                      error={!!errors.email}
                      helperText={errors.email}
                      InputProps={{
                        startAdornment: (
                          <Email sx={{ color: "text.secondary", mr: 1 }} />
                        ),
                      }}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: 2,
                          background: alpha(theme.palette.primary.main, 0.02),
                        },
                      }}
                    />
                  </Box>

                  <TextField
                    fullWidth
                    name="phone"
                    label="Phone Number (Optional)"
                    value={formData.phone}
                    onChange={handleChange}
                    InputProps={{
                      startAdornment: (
                        <Phone sx={{ color: "text.secondary", mr: 1 }} />
                      ),
                    }}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: 2,
                        background: alpha(theme.palette.primary.main, 0.02),
                      },
                    }}
                  />

                  {/* Interest Select */}
                  <FormControl fullWidth error={!!errors.interest}>
                    <InputLabel>What can we help you build?</InputLabel>
                    <Select
                      name="interest"
                      value={formData.interest}
                      onChange={handleSelectChange}
                      label="What can we help you build?"
                      sx={{
                        borderRadius: 2,
                        background: alpha(theme.palette.primary.main, 0.02),
                      }}
                    >
                      {interestOptions.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 2,
                            }}
                          >
                            <Typography
                              variant="h6"
                              sx={{ fontSize: "1.2rem" }}
                            >
                              {option.emoji}
                            </Typography>
                            <Typography>{option.label}</Typography>
                          </Box>
                        </MenuItem>
                      ))}
                    </Select>
                    {errors.interest && (
                      <Typography
                        variant="caption"
                        color="error"
                        sx={{ mt: 1, display: "block" }}
                      >
                        {errors.interest}
                      </Typography>
                    )}
                  </FormControl>

                  {/* Message */}
                  <TextField
                    fullWidth
                    name="message"
                    label="Tell us about your project (Optional)"
                    value={formData.message}
                    onChange={handleChange}
                    multiline
                    rows={3}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: 2,
                        background: alpha(theme.palette.primary.main, 0.02),
                      },
                    }}
                  />

                  {/* Consent */}
                  <Box
                    sx={{
                      p: 2,
                      background: alpha(theme.palette.primary.main, 0.03),
                      borderRadius: 2,
                      border: `1px solid ${errors.consent ? theme.palette.error.main : alpha(theme.palette.primary.main, 0.1)}`,
                    }}
                  >
                    <label
                      style={{
                        display: "flex",
                        alignItems: "flex-start",
                        gap: 2,
                        cursor: "pointer",
                      }}
                    >
                      <CheckCircle
                        sx={{
                          color: formData.consent
                            ? theme.palette.success.main
                            : "action.disabled",
                          mt: 0.5,
                        }}
                      />
                      <Box>
                        <Typography variant="body2" sx={{ fontWeight: 500 }}>
                          I consent to LinXar Labs contacting me about my
                          project needs
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                          We respect your privacy and will never share your
                          information
                        </Typography>
                        {errors.consent && (
                          <Typography
                            variant="caption"
                            color="error"
                            sx={{ mt: 1, display: "block" }}
                          >
                            {errors.consent}
                          </Typography>
                        )}
                      </Box>
                      <input
                        type="checkbox"
                        name="consent"
                        checked={formData.consent}
                        onChange={(e) => {
                          setFormData({
                            ...formData,
                            consent: e.target.checked,
                          });
                          setErrors({ ...errors, consent: "" });
                        }}
                        style={{ display: "none" }}
                      />
                    </label>
                  </Box>

                  {/* Submit Button */}
                  <Button
                    type="submit"
                    variant="contained"
                    size="large"
                    disabled={isSubmitting}
                    endIcon={!isSubmitting && <ArrowForward />}
                    sx={{
                      py: 2,
                      borderRadius: 2,
                      fontWeight: 700,
                      fontSize: "1.1rem",
                      background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%)`,
                      boxShadow: `0 4px 20px ${alpha(theme.palette.primary.main, 0.3)}`,
                      "&:hover": {
                        transform: "translateY(-2px)",
                        boxShadow: `0 8px 30px ${alpha(theme.palette.primary.main, 0.4)}`,
                      },
                      "&:disabled": {
                        background: theme.palette.action.disabled,
                        transform: "none",
                        boxShadow: "none",
                      },
                      transition: "all 0.3s ease",
                    }}
                  >
                    {isSubmitting ? "Sending..." : "Get Your Custom Solution"}
                  </Button>
                </Box>
              </form>

              {/* Footer */}
              <Box sx={{ textAlign: "center", mt: 3 }}>
                <Typography variant="caption" color="text.secondary">
                  🔒 No spam. Unsubscribe at any time. Average response time: 2
                  hours
                </Typography>
              </Box>
            </Box>
          </Box>
        </Fade>
      </Modal>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        TransitionComponent={Slide}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbar.severity}
          sx={{
            width: "100%",
            borderRadius: 2,
            boxShadow: `0 4px 20px ${alpha(theme.palette.common.black, 0.15)}`,
          }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
}
